import { INTEGRATION_PROVIDERS } from '@vy/types';
import type { DeepPartial } from 'react-hook-form';
import type { XeroIntegrationConfiguration } from '@vy/integrations-types';
import type { XeroConfigurationFormValues } from '../XeroConfigurationFormSchema';
import { SYNC_DIRECTIONS } from '../XeroConfigurationFormSchema';
import { nullToUndefined } from '@vy/null';

export function getXeroIntegrationSettings(configuration: XeroConfigurationFormValues) {
  return {
    integrationProvider: INTEGRATION_PROVIDERS.xero,
    integrationConfiguration: mapFormValuesToXeroSettings(configuration),
  };
}

function mapFormValuesToXeroSettings(
  formValues: XeroConfigurationFormValues,
): DeepPartial<XeroIntegrationConfiguration> {
  const autoImportCustomers = formValues.syncCustomer === SYNC_DIRECTIONS.SYNC_TO_VAYU;
  const autoExportInvoices = formValues.syncApprovedInvoices;

  const defaultStripeDepositToAccountId = nullToUndefined(formValues.defaultStripeDepositToAccountId);
  const defaultDepositToAccountId = nullToUndefined(formValues.defaultDepositToAccountId);

  return {
    generalConfig: {
      autoImportCustomers,
      autoExportInvoices,
      autoExportCreditMemos: formValues.autoExportCreditMemos,
      invoiceNumberSyncStrategy: formValues.invoiceNumberSyncStrategy,
      invoicePaymentStatusSyncStrategy: formValues.invoicePaymentStatusSyncStrategy,
      defaultStripeDepositToAccountId,
      defaultDepositToAccountId,
      taxExportStrategy: formValues.taxExportStrategy,
      accountTaxItem: formValues.accountTaxItem,
    },
  };
}
